"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var _DownloadRecordDialog = _interopRequireDefault(require("./components/DownloadRecordDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantStatementDetail',
  components: {
    DownloadRecordDialog: _DownloadRecordDialog.default
  },
  data: function data() {
    return {
      activeTab: 'basic',
      detailLoading: false,
      detail: {},
      orderPram: {
        page: 1,
        limit: 20,
        orderNo: ''
      },
      orderListData: {
        list: [],
        total: 0
      },
      orderLoading: false
    };
  },
  created: function created() {
    var id = this.$route.query.id;
    if (id) {
      this.id = id;
      this.getDetail();
    }
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
    if (this.activeTab === 'orders') {
      this.getOrderList();
    }
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      this.detailLoading = true;
      statementApi.statementDetailApi(this.id).then(function (data) {
        _this.detail = data || {};
        _this.detailLoading = false;
      }).catch(function () {
        _this.detailLoading = false;
      });
    },
    getOrderList: function getOrderList() {
      var _this2 = this;
      this.orderLoading = true;
      statementApi.statementOrderListApi(_objectSpread({
        statementId: this.id
      }, this.orderPram)).then(function (data) {
        _this2.orderListData = data;
        _this2.orderLoading = false;
      }).catch(function () {
        _this2.orderLoading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'orders' && this.orderListData.list.length === 0) {
        this.getOrderList();
      }
    },
    handleOrderSizeChange: function handleOrderSizeChange(val) {
      this.orderPram.limit = val;
      this.getOrderList();
    },
    handleOrderCurrentChange: function handleOrderCurrentChange(val) {
      this.orderPram.page = val;
      this.getOrderList();
    },
    handleResetOrder: function handleResetOrder() {
      this.orderPram.orderNo = '';
      this.orderPram.page = 1;
      this.getOrderList();
    },
    handleOrderDetail: function handleOrderDetail(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          orderNo: row.orderNo
        }
      });
    },
    handleDownload: function handleDownload() {
      this.$refs.downloadDialog.open(this.id, this.detail.statementNo, {
        merchantName: this.detail.merchantName,
        merchantType: this.detail.merchantType,
        periodStart: this.detail.periodStart,
        periodEnd: this.detail.periodEnd
      });
    },
    handleConfirm: function handleConfirm() {
      var _this3 = this;
      this.$confirm('确认该对账单？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        statementApi.statementConfirmApi({
          id: _this3.id
        }).then(function () {
          _this3.$message.success('确认成功');
          _this3.getDetail();
        });
      }).catch(function () {});
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    formatAmount: function formatAmount(val) {
      return val ? Number(val).toFixed(2) : '0.00';
    },
    cycleTypeText: function cycleTypeText(type) {
      var map = {
        day: '日结',
        week: '周结',
        half_month: '半月结',
        month: '月结'
      };
      return map[type] || type || '-';
    },
    merchantTypeText: function merchantTypeText(type) {
      var map = {
        0: '自营商家',
        1: '入驻商家',
        2: '核销商家'
      };
      return map[type] || '-';
    },
    merchantTypeTagType: function merchantTypeTagType(type) {
      var map = {
        0: 'success',
        1: 'warning',
        2: 'primary'
      };
      return map[type] || 'info';
    },
    reconciliationStatusText: function reconciliationStatusText(status) {
      var map = {
        0: '未核对',
        1: '已核对'
      };
      return map[status] || '-';
    },
    reconciliationStatusTagType: function reconciliationStatusTagType(status) {
      var map = {
        0: 'info',
        1: 'success'
      };
      return map[status] || 'info';
    },
    statusText: function statusText(status) {
      var map = {
        0: '待确认',
        1: '已确认',
        2: '已结算',
        3: '生成失败'
      };
      return map[status] || '-';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        0: 'warning',
        1: 'success',
        2: 'success',
        3: 'danger'
      };
      return map[status] || 'info';
    },
    paymentStatusText: function paymentStatusText(status) {
      var map = {
        0: '未打款',
        1: '已打款'
      };
      return map[status] || '-';
    },
    paymentStatusTagType: function paymentStatusTagType(status) {
      var map = {
        0: 'info',
        1: 'success'
      };
      return map[status] || 'info';
    },
    orderStatusType: function orderStatusType(val) {
      var map = {
        completed: 'success',
        pending: 'warning',
        cancelled: 'info',
        refunded: 'danger'
      };
      return map[val] || 'info';
    }
  }
};